module.exports = __webpack_public_path__ + "img/004.0994fb77.png";